import PropTypes from 'prop-types'
import React from 'react'

import AddAndGoToCart from 'containers/AddAndGoToCart'
import { Button } from 'shared/Button'

import {
  Root,
  Photo,
  Content,
  Title,
  Description,
  PriceRow,
  Price,
} from './styles'

const GenomLayout = ({
  title,
  description,
  currentPrice,
  buttonPurchaseText,
  currentSlide,
  mobile,
  isZeroPrice,
}) => {
  return (
    <Root>
      <Photo />

      <Content>
        <Title
          forwardedAs='h1'
          weight='medium'
          size={['65/70', '50/60', '30/35']}
          dangerouslySetInnerHTML={{ __html: title }}
        />
        {description && (
          <Description
            forwardedAs='p'
            size={['18/28', '18/28', '16/25']}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
      </Content>

      <PriceRow>
        {currentPrice && (
          <Price
            weight='medium'
            size={['35/40', '35/40', '25/30']}
          >
            {currentPrice}
          </Price>
        )}

        <AddAndGoToCart
          key={currentSlide?.goodsType}
          goods={[
            {
              type:
                currentSlide?.goodsType === 'microbiome'
                  ? 'biome'
                  : currentSlide?.goodsType,
              isSubscription: false,
            },
          ]}
          buttonProps={{
            color: 'white',
            size: mobile ? 'mobile' : 'desktop',
            disabled: isZeroPrice,
          }}
          ButtonComponent={Button}
          forceMultipleAdd
        >
          {buttonPurchaseText}
        </AddAndGoToCart>
      </PriceRow>
    </Root>
  )
}

GenomLayout.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  currentPrice: PropTypes.string,
  buttonPurchaseText: PropTypes.string.isRequired,
  currentSlide: PropTypes.object.isRequired,
  mobile: PropTypes.bool,
  isZeroPrice: PropTypes.bool,
}

export default GenomLayout
